
import React from 'react';
import './main.css';

const Footer = () => {
    return (
    <div className="footer">
        <a href="https://www.linkedin.com/in/aidan-venckus" className="fa fa-linkedin" aria-label="LinkedIn"> </a>
        <a href="https://www.instagram.com/aidanvenckus/" className="fa fa-instagram" aria-label="Instagram"> </a>
        <a href="https://github.com/Aidanvenckus" className="fa fa-github" aria-label="GitHub"> </a>
    </div>
    );
  };

  export default Footer;
